"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const DocumentPageContainer = styled_components_1.default.div `
  height: 100vh;
  background-color: ${(props) => props.theme.palette.mainAppColor.main};
  display: flex;

  animation-duration: ${(props) => props.fadeInContentAnimation * 1}s;

  object {
    width: 100%;
    object-fit: contain;
  }

  .doc {
    animation-duration: ${(props) => props.fadeInDocumentAnimation * 1}s;

    &.fading-out {
      animation-duration: ${(props) => props.fadeOutDocumentAnimation * 1}s;
    }
  }

  .hidden {
    display: none;
  }
`;
const FADE_OUT_DOC = 1 * 1000;
const FADE_IN_DOC = 1 * 1000;
const DocumentPage = (props) => {
    const { content, openNextSlide, settings, setCurrentSlideDuration } = props;
    const { speed } = settings;
    const changeSlideTimeout = (0, react_1.useRef)(null);
    const enterFadeInTimeout = (0, react_1.useRef)(null);
    const exitFadeOutTimeout = (0, react_1.useRef)(null);
    const fadeInContentTimeout = (0, react_1.useRef)(null);
    const clearTimeouts = () => {
        clearTimeout(changeSlideTimeout.current);
        clearTimeout(enterFadeInTimeout.current);
        clearTimeout(exitFadeOutTimeout.current);
        clearTimeout(fadeInContentTimeout.current);
    };
    const fadeOutContent = () => {
        // console.log( "fading out" );
        if (!settings.stopSlideShow) {
            document.getElementsByClassName("doc")[0].classList.add("fading-out");
            document
                .getElementsByClassName("doc")[0]
                .classList.add("animate__fadeOut");
        }
        exitFadeOutTimeout.current = setTimeout(() => {
            // console.log( "----document slide end----" );
            if (!settings.stopSlideShow) {
                openNextSlide();
            }
        }, FADE_OUT_DOC / speed);
    };
    const displayContent = () => {
        // console.log( "displaying content " );
        changeSlideTimeout.current = setTimeout(() => {
            fadeOutContent();
        }, settings.changeSlideInterval);
    };
    const fadeInDoc = () => {
        // console.log( "fade in content" );
        document.getElementsByClassName("doc")[0].classList.remove("hidden");
        document.getElementsByClassName("doc")[0].classList.add("animate__fadeIn");
        fadeInContentTimeout.current = setTimeout(() => {
            displayContent();
        }, FADE_IN_DOC / speed);
    };
    const enterFadeInAnimation = () => {
        // console.log( "fading in all" );
        enterFadeInTimeout.current = setTimeout(() => {
            fadeInDoc();
        }, settings.fadeInContentTime);
    };
    (0, react_1.useEffect)(() => () => {
        clearTimeouts();
    }, []);
    (0, react_1.useEffect)(() => {
        clearTimeouts();
        setCurrentSlideDuration(settings.fadeInContentTime +
            FADE_IN_DOC / speed +
            settings.changeSlideInterval +
            FADE_OUT_DOC / speed);
        enterFadeInAnimation();
    }, [content]);
    const isLandscape = window.innerWidth >= window.innerHeight;
    const fitSetting = isLandscape ? "FitV" : "FitH";
    const doc = content.contentType === "application/pdf" ? (react_1.default.createElement("iframe", { className: "doc animate__animated hidden", src: `${content.dataUrl}#view=${fitSetting}&toolbar=0`, height: "100%", width: "100%", title: "pdf-display" })) : (react_1.default.createElement("object", { className: "doc animate__animated hidden", data: `${content.dataUrl}`, type: content.contentType, "aria-label": content.title }));
    return (react_1.default.createElement(DocumentPageContainer, { fadeInContentAnimation: settings.fadeInContentTime / 1000, fadeInDocumentAnimation: FADE_IN_DOC / speed / 1000, fadeOutDocumentAnimation: FADE_OUT_DOC / speed / 1000, className: "document-page-container animate__animated animate__fadeIn" }, doc));
};
exports.default = DocumentPage;
